module.exports = __webpack_public_path__ + "img/1-3.409c6723.svg";